"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStyles = void 0;
var react_1 = __importStar(require("react"));
var clsx_1 = __importDefault(require("clsx"));
var styles_1 = require("@material-ui/core/styles");
var editor_web_1 = require("@21st-night/editor-web");
var Typography_1 = __importDefault(require("@material-ui/core/Typography"));
var Grid_1 = __importDefault(require("@material-ui/core/Grid"));
var RichText_1 = __importDefault(require("../../RichText"));
var LoadingIndicator_1 = __importDefault(require("../../LoadingIndicator"));
exports.useStyles = styles_1.makeStyles(function () { return ({
    root: {
        width: '100%',
    },
    content: {
        display: 'flex',
        flexDirection: 'column',
    },
}); });
var CardNote = function (_a) {
    var classNameProp = _a.className, cardId = _a.cardId, loading = _a.loading, note = _a.note, other = __rest(_a, ["className", "cardId", "loading", "note"]);
    var classes = exports.useStyles();
    return (react_1.default.createElement("div", __assign({ className: clsx_1.default(classes.root, classNameProp) }, other),
        react_1.default.createElement(Grid_1.default, { container: true, spacing: 4, justify: "center" },
            react_1.default.createElement(Grid_1.default, { item: true, xs: 12, md: 8, className: classes.content },
                loading && react_1.default.createElement(LoadingIndicator_1.default, { size: "large" }),
                !loading && (react_1.default.createElement(react_1.Fragment, null,
                    react_1.default.createElement(Typography_1.default, { variant: "h3", gutterBottom: true }, note.title),
                    react_1.default.createElement(RichText_1.default, { document: editor_web_1.deserializeDocument(note.content) })))))));
};
exports.default = CardNote;
//# sourceMappingURL=CardNote.js.map